export const MY_TEAM_BASE_FRAGMENT = '/my-team';
export const CERTIFICATIONS_BY_TEAM_PATH = `${MY_TEAM_BASE_FRAGMENT}/certifications-by-team`;
export const ACTIVE_CERTIFICATIONS_BY_TEAM_PATH = `${CERTIFICATIONS_BY_TEAM_PATH}/active`;
export const IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH = `${CERTIFICATIONS_BY_TEAM_PATH}/in-progress`;
export const EXPIRED_CERTIFICATIONS_BY_TEAM_PATH = `${CERTIFICATIONS_BY_TEAM_PATH}/expired`;
export const CERTIFICATIONS_INDEX_PATH = `${MY_TEAM_BASE_FRAGMENT}/certifications`;
export const CERTIFICATIONS_PROFILE_BASE = CERTIFICATIONS_INDEX_PATH;
export const TEAM_MEMBERS_PATH = `${MY_TEAM_BASE_FRAGMENT}/members`;
export const LEGACY_MY_TEAM_URL_FRAGMENT = '/team';

// Playlists
export const PLAYLISTS_BASE_PATH = `${MY_TEAM_BASE_FRAGMENT}/playlists`;
export const ALL_PLAYLISTS_PATH = `${PLAYLISTS_BASE_PATH}/all`;
export const COMPLETED_PLAYLISTS_PATH = `${PLAYLISTS_BASE_PATH}/completed`;
export const INCOMPLETE_PLAYLISTS_PATH = `${PLAYLISTS_BASE_PATH}/incomplete`;

// Assigned Content
export const CONTENT_BASE_PATH = `${MY_TEAM_BASE_FRAGMENT}/content`;
export const ALL_CONTENT_PATH = `${CONTENT_BASE_PATH}/all`;